const $ = jQuery;

// Selector constants
const SELECTORS = {
    DROPDOWN: '.js-filter-dropdown',
    LABEL: '.js-filter-dropdown--label',
    CONTAINER: '.js-filter-dropdown--container',
    OPTION: '.js-filter-dropdown--option',
};

/**
 * Initializes filter dropdown functionality
 */
const initFilterDropdowns = () => {
    const filterDropdowns = $(SELECTORS.DROPDOWN);
    if (!filterDropdowns.length) return;

    filterDropdowns.each(initializeDropdown);

    if (!filterDropdowns.hasClass('first-open')) {
        setupGlobalClickHandler();
    }
};

/**
 * Initializes a single dropdown
 * @param {number} index - Current element index
 * @param {HTMLElement} element - Dropdown DOM element
 */
const initializeDropdown = (index, element) => {
    const $dropdown = $(element);
    const $label = $dropdown.find(SELECTORS.LABEL);
    const $container = $dropdown.find(SELECTORS.CONTAINER);

    setupLabelClickHandler($dropdown, $container);
    setupOptionsClickHandler($dropdown, $label, $container);
};

/**
 * Sets up click handler for dropdown label
 * @param {jQuery} $dropdown - Dropdown jQuery element
 * @param {jQuery} $container - Container jQuery element
 */
const setupLabelClickHandler = ($dropdown, $container) => {
    $dropdown.find(SELECTORS.LABEL).on('click', function () {
        $dropdown.toggleClass('open');
        $container.slideToggle();
    });
};

/**
 * Sets up click handler for dropdown options
 * @param {jQuery} $dropdown - Dropdown jQuery element
 * @param {jQuery} $label - Label jQuery element
 * @param {jQuery} $container - Container jQuery element
 */
const setupOptionsClickHandler = ($dropdown, $label, $container) => {
    $dropdown.find(SELECTORS.OPTION).on('click', function () {
        const $option = $(this);
        updateSelectedOption($dropdown, $option);

        // if (!$dropdown.hasClass('sort')) {
        //     updateLabel($label, $option);
        // }

        if (!$dropdown.hasClass('first-open')) {
            closeDropdown($dropdown, $container);
        }
    });
};

/**
 * Updates the selected option in the dropdown
 * @param {jQuery} $dropdown - Dropdown jQuery element
 * @param {jQuery} $option - Selected option jQuery element
 */
const updateSelectedOption = ($dropdown, $option) => {
    $dropdown.find(SELECTORS.OPTION).removeClass('selected');
    $option.addClass('selected');
};

/**
 * Updates the dropdown label text
 * @param {jQuery} $label - Label jQuery element
 * @param {jQuery} $option - Selected option jQuery element
 */
const updateLabel = ($label, $option) => {
    const isAllOption = $option.data('value') === 'all';
    $label.text(isAllOption ? $label.data('label') : $option.text());
};

/**
 * Closes the dropdown
 * @param {jQuery} $dropdown - Dropdown jQuery element
 * @param {jQuery} $container - Container jQuery element
 */
const closeDropdown = ($dropdown, $container) => {
    $dropdown.removeClass('open');
    $container.slideUp();
};

/**
 * Sets up global click handler for closing dropdowns
 */
const setupGlobalClickHandler = () => {
    $(document).on('click', function (e) {
        if (!$(e.target).closest(SELECTORS.DROPDOWN).length) {
            $(SELECTORS.DROPDOWN).removeClass('open');
            $(SELECTORS.CONTAINER).slideUp();
        }
    });
};

export default initFilterDropdowns;
